import { motion } from "framer-motion";
import { usePxToVw } from "../hooks/usePxToVw";

import {
  FaPowerOff,
  FaToggleOn,
  FaToggleOff,
 
} from "react-icons/fa";
import { LuPowerOff } from "react-icons/lu";
import {
  MdClosedCaption,
  MdClosedCaptionOff,
} from "react-icons/md";



const CCToggle = ({ value, onChange, captionSettings }) => {
  const isOn = value;
  const { pxToVw } = usePxToVw();

  console.log('icon cc ', captionSettings)

  // Default settings
  const settings = {
    iconType: captionSettings?.iconType || 'toggle',
    iconSize: captionSettings?.iconSize || 50,
    iconOnColor: captionSettings?.iconOnColor || '#4CAF50',
    iconOffColor: captionSettings?.iconOffColor || '#757575',
    buttonTop: captionSettings?.buttonTop || 10,
    buttonLeft: captionSettings?.buttonLeft || 10,
    showLabel: captionSettings?.showLabel || false,
  };

 
  const getReactIcon = () => {
    const iconSize = `${pxToVw(settings.iconSize)}`;
    const color = isOn ? settings.iconOnColor : settings.iconOffColor;

    switch (settings.iconType.toLowerCase()) {
      case 'power':
        return isOn ?
          <FaPowerOff size={iconSize} color={color} /> :
          <LuPowerOff size={iconSize} color={color} />;

      case 'caption':
        return isOn ?
          <MdClosedCaption size={iconSize} color={color} /> :
          <MdClosedCaptionOff size={iconSize} color={color} />;

      case 'toggle':
      default:
        return isOn ?
          <FaToggleOn size={iconSize} color={color} /> :
          <FaToggleOff size={iconSize} color={color} />;
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    onChange(!isOn);
  };

  const currentIcon = getReactIcon(); // Or getReactIcon() if using React Icons

  console.log('curretico', currentIcon)

  return (
    <motion.div
      onClick={handleClick}
      onPointerDown={(e) => e.stopPropagation()}
      whileTap={{ scale: 0.9 }}
      whileHover={{ scale: 1.1 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
      style={{
        position: "fixed",
        top: `${settings.buttonTop}%`,
        left: `${settings.buttonLeft}%`,
        width: `${pxToVw(settings.iconSize)}`, // Adjust button size based on icon
        height: `${pxToVw(settings.iconSize)}`,
        borderRadius: "50%",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // background: isOn ? "#ffffffdd" : "#000000a8",
        zIndex: 9999,
        // transform: 'translate(-50%, -50%)',
        // border: `2px solid ${isOn ? settings.iconOnColor : settings.iconOffColor}`,
        // boxShadow: `0 4px 12px ${isOn ? settings.iconOnColor + '40' : settings.iconOffColor + '40'}`,
      }}
      title={isOn ? 'Captions ON' : 'Captions OFF'}
    >
      {currentIcon}

      {/* Optional label */}
      {settings.showLabel && (
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          style={{
            position: 'absolute',
            bottom: `${pxToVw(-25)}vw`,
            fontSize: `${pxToVw(12)}vw`,
            color: isOn ? settings.iconOnColor : settings.iconOffColor,
            fontWeight: 'bold',
            textShadow: '0 1px 2px rgba(0,0,0,0.5)',
          }}
        >
          {isOn ? 'CC ON' : 'CC OFF'}
        </motion.span>
      )}
    </motion.div>
  );
};

export default CCToggle;